import { useState } from "react";
import { IconClose } from "../icons/Icons";

const SELECT_ARROW = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23666'/%3E%3C/svg%3E")`;

const selectStyle = {
  width: "100%", padding: "7px 10px", border: "1px solid #ccc", borderRadius: 6,
  fontSize: 12, color: "#333", background: "white", cursor: "pointer", outline: "none",
  appearance: "none", backgroundImage: SELECT_ARROW,
  backgroundRepeat: "no-repeat", backgroundPosition: "right 10px center",
};
const labelStyle = { fontSize: 11, fontWeight: 600, color: "#555", marginBottom: 4, display: "block" };

const DEFAULT_SETTINGS = { vehicleType: "all", status: "all", plant: "all", period: "year" };

export default function SettingsSidebar({ onClose }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [saved, setSaved] = useState(false);

  function set(field, value) {
    setSettings(s => ({ ...s, [field]: value }));
  }

  function handleSave() {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  return (
    <>
      {/* Backdrop */}
      <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.25)", zIndex: 200 }} />

      {/* Sidebar panel */}
      <div style={{
        position: "fixed", top: 0, right: 0, bottom: 0, width: 300,
        background: "white", boxShadow: "-4px 0 20px rgba(0,0,0,0.15)",
        zIndex: 201, display: "flex", flexDirection: "column",
        animation: "slideIn 0.22s ease",
      }}>
        <style>{`@keyframes slideIn { from { transform:translateX(100%); } to { transform:translateX(0); } }`}</style>

        {/* Header */}
        <div style={{ background: "#1e6b6b", color: "white", padding: "14px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
          <span style={{ fontSize: 14, fontWeight: 600 }}>Settings</span>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "white", display: "flex", alignItems: "center", padding: 2 }}>
            <IconClose />
          </button>
        </div>

        {/* Content */}
        <div style={{ flex: 1, padding: 18, display: "flex", flexDirection: "column", gap: 18, overflowY: "auto" }}>
          <div>
            <label style={labelStyle}>Vehicle Type</label>
            <select style={selectStyle} value={settings.vehicleType} onChange={e => set("vehicleType", e.target.value)}>
              <option value="all">All Types</option>
              <option value="chassis">Chassis</option>
              <option value="cab">Cab</option>
              <option value="combo">Combo</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Status</label>
            <select style={selectStyle} value={settings.status} onChange={e => set("status", e.target.value)}>
              <option value="all">All Statuses</option>
              <option value="HG0">HG0</option>
              <option value="HG1">HG1</option>
              <option value="HG2">HG2</option>
              <option value="HG3">HG3</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Plant</label>
            <select style={selectStyle} value={settings.plant} onChange={e => set("plant", e.target.value)}>
              <option value="all">All Plants</option>
              <option value="munich">Munich</option>
              <option value="steyr">Steyr</option>
              <option value="vienna">Vienna</option>
              <option value="berlin">Berlin</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Period</label>
            <select style={selectStyle} value={settings.period} onChange={e => set("period", e.target.value)}>
              <option value="quarter">Quarter</option>
              <option value="half">Half Year</option>
              <option value="year">Full Year</option>
              <option value="custom">Custom</option>
            </select>
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: "14px 18px", borderTop: "1px solid #eee", flexShrink: 0 }}>
          <button
            onClick={handleSave}
            style={{
              width: "100%", padding: "9px 0", border: "none", borderRadius: 6,
              fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "background 0.3s",
              background: saved ? "#28a745" : "#1e6b6b", color: "white",
            }}
          >
            {saved ? "✓ Saved" : "Save"}
          </button>
        </div>
      </div>
    </>
  );
}
